import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class ModeAndMediumService {

  constructor(private http: HttpClient) {}

  async GetModeAndMedium(id) {
    try { 
      let response = await this.http
        .get(`${appApiResources.getModeAndMedium}${id}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}